var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.57143C0 0.703553 0.703553 0 1.57143 0H2.2899C2.74057 0 3.13341 0.30672 3.24272 0.743938L3.82194 3.06084C3.91778 3.4442 3.77454 3.84767 3.45841 4.08476L2.7808 4.59297C2.71044 4.64574 2.69514 4.72302 2.7149 4.77698C3.3097 6.40068 4.59932 7.69031 6.22302 8.2851C6.27698 8.30486 6.35426 8.28956 6.40703 8.2192L6.91524 7.54159C7.15233 7.22546 7.55579 7.08222 7.93916 7.17806L10.2561 7.75728C10.6933 7.86659 11 8.25943 11 8.7101V9.42857C11 10.2964 10.2964 11 9.42857 11H8.25C3.69365 11 0 7.30635 0 2.75V1.57143Z",
    fill: "#0F1111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconSmall);
export default __webpack_public_path__ + "static/media/phoneIconSmall.45f0ee335709c13839aa81d48631de4a.svg";
export { ForwardRef as ReactComponent };